import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {useApi} from "../hooks/api-hook";
import {API_SPEC} from "../spec/apiSpec";
import {useDispatch, useSelector} from "react-redux";
import {InputAdornment} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {useNavigate} from "react-router";
import {defaultInitState} from "../reducers/reducerDefaults";
import IconButton from '@mui/material/IconButton';
import {useSearchParams} from "react-router-dom";
import debounce from 'lodash/debounce';
import {saveSearchPrompt, writeSearchPrompt} from "../reducers/controlsReducer";
import MenuItem from '@mui/material/MenuItem';

const showCards = [
    {
      value: 'latest',
      label: 'Show only latest version',
    },
    {
      value: 'all',
      label: 'Show all versions',
    },
  ];

export default function Search() {
    const [open, setOpen] = React.useState(false);
    const {searchPrompt, searchPromptAuto} = useSelector((state) => state.controlsReducer)
    const [options, setOptions] = React.useState([]);
    const {isLoading, data, api, initialized} = useApi();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch  = useDispatch();

    const q = searchParams.get("q");

    const {items: cards} = useSelector((state) => state.cardReducer)
    const navigate = useNavigate()
    const {page, rowsPerPage} = useSelector((state) => state.controlsReducer)

    const send = (value) => {
        const card_spec = API_SPEC.SEARCH_CARDS({q: value, page: page, size: rowsPerPage})
        api(card_spec);
        dispatch(saveSearchPrompt(value));
    }


    const debouncedSendToServer = React.useRef(debounce((value) => {
        console.debug("useEffect: value", value, isLoading)
        if (!isLoading && !!value && value.length > 1) {
            navigate('/search?q=' + value);
            send(value);
        }
    }, 500)).current;

    React.useEffect(() => {
        return () => {
            debouncedSendToServer.cancel();
        };
    }, [debouncedSendToServer]);

    React.useEffect(() => {
        if (!initialized || searchPromptAuto) return;
        debouncedSendToServer(searchPrompt);
    }, [searchPrompt, searchPromptAuto, initialized]);

    React.useEffect(() => {
        console.debug("useEffect: q", q, isLoading)
        if (!isLoading && !!q) {
            send(q)
        }
    }, [q, initialized]);

    React.useEffect(() => {
        if (open) {
            setOptions(cards);
        } else {
            setOptions(defaultInitState.items);
        }
    }, [cards, open])

    return (
        <Autocomplete
            id="input-with-icon-search"
            sx={{width: '100%', flexGrow: 1}}
            freeSolo
            disableClearable
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            onInputChange={(event, value, reason) => {
                dispatch(writeSearchPrompt(value));
            }}
            inputValue={searchPrompt ? searchPrompt : ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => !!option.name ? option.name : option}
            options={options}
            loading={isLoading}
            filterOptions={x => x}
            forcePopupIcon={false}
            renderInput={(params) => (
                <TextField variant={"outlined"} sx={{
                    backgroundColor: "#fff",
                    borderRadius: 1,
                    display: "flex",
                    maxWidth: "fit-content(20em)",
                    flexGrow: 1
                }}
                           {...params}
                           onKeyDown={(e) => {
                               if (e.key === "Enter" && e.target.value) {
                                   navigate('/search?q=' + e.target.value)
                               }
                           }}
                           InputProps={{
                               ...params.InputProps,
                               endAdornment: (
                                   <InputAdornment position="end">
                                    {/* <TextField
                                        id="filled-select-currency"
                                        select
                                        hiddenLabel
                                        defaultValue="latest"
                                        variant="filled"
                                        sx={{width:240}}
                                        >
                                        {showCards.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField> */}
                                       <IconButton color="primary" aria-label="upload picture" component="label"
                                                   onClick={() => navigate('/search?q=' + searchPrompt)}>
                                           <SearchIcon/>
                                       </IconButton>
                                   </InputAdornment>
                               )
                           }}
                />
            )}
        />
    );
}
